var $6a28db60575518b2$exports = {};
$6a28db60575518b2$exports = {
    "maximum": `Maximum`,
    "minimum": `Minimum`
};


export {$6a28db60575518b2$exports as default};
//# sourceMappingURL=nl-NL.mjs.map
